<template lang="pug">
  .RegisterSuccessForm.body.form-success

    transition(name="grow")
      .mail-circle(v-if="mailCircleVisible")
        transition(name="fly")
          IconFlyingMail(v-if="flyingMailVisible")

    .header
      transition(name="upwards-fade-in")
        h2.title.u-text-width-bold.u-color-blue(v-if="titleVisible")
          | {{$t('auth.msg.register_form_success_mail_activation')}}
      transition(name="upwards-fade-in")
        .desc(v-if="descVisible")
          p(v-html="$t('auth.msg.register_form_success_activation_msg', [form.email])")
    
    transition(name="upwards-fade-in")
      .login-container(v-if="loginVisible")
        button.btn.btn-primary.login(
          type="button"
          @click="onLogin"
        )
            | {{$t('auth.action.back_to_login')}}

</template>

<script>
  import SuccessCircle from '@/component/success-circle'

  export default {
    name: 'register-form-success',
    components: {
      SuccessCircle
    },
    props: [
      'form'
    ],
    data() {
      return {
        mailCircleVisible: false,
        flyingMailVisible: false,
        titleVisible: false,
        descVisible: false,
        loginVisible: false
      }
    },
    methods: {
      onLogin() {
        this.$router.push({name: "login"})
      }
    },
    mounted() {
      setTimeout(() => {
        this.mailCircleVisible = true
      }, 300)

      setTimeout(() => {
        this.flyingMailVisible = true
      }, 300)

      setTimeout(() => {
        this.titleVisible = true
      }, 500)

      setTimeout(() => {
        this.descVisible = true
      }, 600)

      setTimeout(() => {
        this.loginVisible = true
      }, 700)
    }
  }
</script>

<style lang="scss" scoped>

  .RegisterSuccessForm {
    min-height: 400px;
    display: block !important;

    .mail-circle {
      width: 110px;
      height: 110px;
      color: $color-blue;
      background-color: rgba($color-blue, .2);
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
      margin-bottom: 32px;

      .icon {
        position: relative;
        left: -5px;
      }
    }

    .desc {
      padding: 32px;
      background-color: rgba(204, 231, 255, 0.23);
      border-radius: $border-radius;
      color: rgba(0, 38, 64, 0.5);
      font-size: 16px;

      .bold {
        color: $color-navy;
      }
    }

    .login-container {
      display: flex;
      justify-content: center;
    }
    

    // Grow

    .grow-enter-active, .grow-leave-active {
      transition: all .5s;
    }

    .grow-enter, .grow-leave-to {
      width: 80px;
      height: 80px;
      opacity: 0;
    }

    // Fly

    .fly-enter-active, .fly-leave-active {
      transition: all .4s;
    }

    .fly-enter, .fly-leave-to {
      transform: translateX(-90px) translateY(40px);
      opacity: 0;
    }

    // Upwards fade in

    .upwards-fade-in-enter-active, .upwards-fade-in-leave-active {
      transition: all .5s;
      transform: translateY(0);
      opacity: 1;
    }

    .upwards-fade-in-enter, .upwards-fade-in-leave-to {
      transform: translateY(50px);
      opacity: 0;
    }

  }

</style>